module.exports = __webpack_public_path__ + "img/iteration-CP2.1238dc62.png";